define.alias("checkout/components/seamless-checkout/plan-card", "settings/components/seamless-checkout/plan-card");